var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.layout === 1)?_c('Layout1'):_vm._e(),(_vm.item.layout === 2)?_c('Layout2'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }